module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slider",
    staticClass: "slider"
  }, [_c('div', {
    ref: "sliderGroup",
    staticClass: "slider-group"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "dots"
  }, _vm._l((_vm.dots), function(item, index) {
    return _c('span', {
      staticClass: "dot",
      class: {
        active: _vm.currentPageIndex === index
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee7e316a","hasScoped":true}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = 521
// module chunks = 2 3